/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_EyebrowInputs */

const en_directory_vibebids_eyebrow = /** @type {(inputs: Directory_Vibebids_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids`)
};

const zh_directory_vibebids_eyebrow = /** @type {(inputs: Directory_Vibebids_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids`)
};

/**
* | output |
* | --- |
* | "VibeBids" |
*
* @param {Directory_Vibebids_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_eyebrow = /** @type {((inputs?: Directory_Vibebids_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_eyebrow(inputs)
	return zh_directory_vibebids_eyebrow(inputs)
});
export { directory_vibebids_eyebrow as "directory.vibebids.eyebrow" }